/**
 * A template literal tag that parses GraphQL query strings into a string.
 *
 * This is related to the `gql` tag in the `graphql-tag` package, but returns a string instead of
 * an AST.
 */
export const gql = String.raw
